import React from "react"
import { Platform } from "~/ui/primitives"
import { InputTextFloatLabel } from "~components/input-text"
import { rules } from "~utils/validator"

const isIOS = Platform.OS === "ios"
interface Props {
  value: string
  placeholder?: string
  onChange: (value: string) => void
}

const Username: React.FC<Props> = ({ value, onChange, ...rest }) => (
  <InputTextFloatLabel
    label="昵称"
    keyboardType={isIOS ? "ascii-capable" : "visible-password"}
    placeholder="请输入昵称"
    value={value}
    onChangeText={onChange}
    validRule={rules.displayname}
    {...rest}
  />
)

export default Username
